import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export const matchesInterval =
  (interval: number): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null =>
    !control.value || isNaN(control.value) || control.value % interval === 0 ? null : {wrongInterval: control.value};
